module.exports = __webpack_public_path__ + "img/local_airport_black_24dp.a77121ce.svg";